// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"676":"component---src-templates-demolition-kpp-pages-js","684":"cada2cc6","774":"framework"}[chunkId] || chunkId) + "-" + {"306":"053a53598cd54645234e","589":"e5755b5cf428fee68086","676":"51cf42c391c5186a47cb","684":"15de4de5c01a9c8bab3b","774":"64fb867057913ead4b67"}[chunkId] + ".js";
};